import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { get as _get } from "lodash";

// components mui
import { Box, Button, IconButton, List, TextField, Modal, Typography } from "@mui/material";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
// Validation
import { regexBtcAddress } from "../../../utils/regex";

// contract
import { loadTokenData } from "../../../utils/token";

// Actions
import { setModalData, setModal } from "../../../redux/actions/modals";
import { setCustomTokenData } from "../../../redux/actions/tokens";

// Local Storage
import LS from "../../../helpers/storage";

// components
import ModalHeader from "../ModalHeader";
import TokenListItem from "../../TokenListItem";

const ModalManageToken = () => {
  //hooks
  const dispatch = useDispatch();

  // state
  const [tokenResult, setTokenResult] = useState(null); // tokenTextField
  const [errorMessage, setErrorMessage] = useState(null); // tokenTextField

  // selectors
  const currentModal = useSelector((state) => state.modals.modal);
  const currentModalData = useSelector((state) => state.modals.data);
  const custom_tokens = useSelector((state) => state.tokens.custom_tokens);
  const base_tokens = useSelector((state) => state.tokens.base_tokens);

  // functions
  const closeModal = () => {
    dispatch(setModal(null));
    dispatch(setModalData(null));
  };
  const backModal = () => {
    dispatch(setModal("SelectToken"));
  };
  const deleteToken = (token) => {
    const newList = custom_tokens.filter((_token) => _token.address != token.address);
    LS.custom_tokens(newList);
    dispatch(setCustomTokenData(newList));
  };
  const importToken = (token) => {
    // clean search token
    setTokenResult(null);
    // import token
    dispatch(setModal("ImportToken"));
    dispatch(setModalData({ ...currentModalData, token }));
  };
  const contractLookUp = async (e) => {
    setTokenResult(null);
    let address = e.target.value;
    if (regexBtcAddress(address)) {
      // check token exist
      let existToken = base_tokens.concat(custom_tokens).find((_token) => _token.address == address);

      if (existToken) {
        setErrorMessage("Token already exists in token list");
        setTimeout(() => {
          setErrorMessage(null);
        }, 5000);
        return;
      }
      // import token from contract
      const result = await loadTokenData(address);
      setTokenResult(result);
    }
  };

  const shortAddress = (address) => (address.length > 16 ? `${address.slice(0, 8)}…${address.slice(-6)}` : address);

  return (
    <Modal open={currentModal === "ManageToken"} onClose={closeModal} sx={{ display: "flex", p: 2 }}>
      <Box
        sx={{
          width: "100%",
          maxWidth: 420,
          maxHeight: "calc(100vh - 32px)",
          m: "auto",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <ModalHeader title={"Manage tokens"} closeFunction={closeModal} backArrow={backModal} />
        <Box sx={{ px: 2.5, pb: 2 }}>
          <TextField
            id="outlined-search"
            placeholder="Paste a token contract address"
            type="text"
            fullWidth
            onChange={contractLookUp}
            error={Boolean(errorMessage)}
            helperText={errorMessage || "Custom tokens are saved in this browser."}
            slotProps={{ htmlInput: { "aria-label": "token contract address" } }}
          />
        </Box>
        {tokenResult ? (
          <List sx={{ borderTop: 1, borderColor: "divider", py: 1 }}>
            <TokenListItem
              token={tokenResult}
              secondary={shortAddress(_get(tokenResult, "address", ""))}
              action={
                <Button size="small" variant="contained" onClick={() => importToken(tokenResult)}>
                  Import
                </Button>
              }
            />
          </List>
        ) : null}
        <Box sx={{ borderTop: 1, borderColor: "divider", overflowY: "auto", py: 1 }}>
          <Typography variant="body2" sx={{ color: "text.secondary", px: 2.5, py: 1 }}>
            {custom_tokens.length === 0
              ? "No custom tokens yet. Paste a contract address above to add one."
              : custom_tokens.length === 1
                ? "1 custom token"
                : `${custom_tokens.length} custom tokens`}
          </Typography>
          <List disablePadding>
            {custom_tokens.map((token, key) => (
              <TokenListItem
                key={key}
                token={token}
                secondary={shortAddress(_get(token, "address", ""))}
                action={
                  <IconButton
                    edge="end"
                    aria-label={`remove ${_get(token, "symbol", "token")}`}
                    onClick={() => deleteToken(token)}
                  >
                    <DeleteOutlinedIcon fontSize="small" />
                  </IconButton>
                }
              />
            ))}
          </List>
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalManageToken;
